module.exports = __webpack_public_path__ + "img/centerIonc4.91165fce.png";